import AssessmentMetricFields from './AssessmentMetricFields'
import BehaviorMetricFields from './BehaviorMetricFields'
import AttendanceMetricFields from './AttendanceMetricFields'

export default {
    AssessmentMetricFields, BehaviorMetricFields, AttendanceMetricFields
}
